import { SIGNED_OUT_STORAGE_KEY } from '@/constants/auth';

/**
 * Per tab, because the sign-out it records is what this tab's own sign-in
 * screen has to explain. It outlives the trip to the identity provider's
 * end-session page, which is the point: on the way back the app must not
 * send the person straight to sign in again.
 */
export const readSignedOut = (): boolean => {
  try {
    return window.sessionStorage.getItem(SIGNED_OUT_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

export const writeSignedOut = (signedOut: boolean): void => {
  try {
    if (signedOut) window.sessionStorage.setItem(SIGNED_OUT_STORAGE_KEY, '1');
    else window.sessionStorage.removeItem(SIGNED_OUT_STORAGE_KEY);
  } catch {
    /* storage is optional */
  }
};
